module.exports = __webpack_public_path__ + "static/media/story.c44ab97b.png";